const Label = require('../../components/global/components/Label');
const _ = require('lodash');
const React = require('react');
const createReactClass = require('create-react-class');
const assign = require('object-assign');
const FuzzyReaction = require('../../bootstrap').FuzzyReaction;
const Table = FuzzyReaction.Components.Visualization.Tables.Table;
const Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
const PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
const Filter = FuzzyReaction.Components.Visualization.Filter;
const PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
const Modal = FuzzyReaction.Components.Global.Modal;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const Button = FuzzyReaction.Components.Global.Button;
const SubscriptionsApi = require('../../api-utils/SubscriptionsApi');
const SubscribersStore = require('../../stores/SubscribersStore');
const DayPicker = require('react-day-picker');
require('react-day-picker/lib/style.css');

/**
 * The Users list page view component
 *
 * @type {*|Function}
 */
const SubscribersPage = createReactClass({
    displayName: 'SubscribersPage',

    getInitialState: function () {
        this.handleDayClick = this.handleDayClick.bind(this);
        return {
            currentPageData: [],
            workingResource: {},
            openDeactivateModal: false,
            showUserViewModal: false,
            showUserEditModal: false,
            reverifyLoading: false,
        }
    },

    formKey: "editExpiration",

    /**
     * Set up resource actions
     */
    resourceActions: new ResourceActions('users'),

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            include: ['receipts.product', 'activity_level'],
            filters: {
                blank: '!instructor' // Filter doesn't care about column name for ! filter
            },
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {
            include: ['receipts.product', 'activity_level'],
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data',
        refresh: 'list'
    },

    /**
     * Fire an action to request data from the API
     */
    requestTableData: function (modifiers) {
        // Merge modifiers with already present ones
        this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});

        this.resourceActions.listResource(this.getOptions);
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        this.requestTableData();

        this.changeListener = this._onChange;
        SubscribersStore.addChangeListener(this.changeListener);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        SubscribersStore.removeChangeListener(this.changeListener);
    },

    /**
     * Handle changes in data and request paginated data
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            currentPageData: SubscribersStore.getResourceListData()
        });

        if (this.state.showUserEditModal) {
            let user = _.cloneDeep(SubscribersStore.getResource());

            this.setState({
                workingResource: user,
                reverifyLoading: false
            });
        }
    },

    /**
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        switch (action) {
            case 'deactivate':
                this.setState({
                    openDeactivateModal: true,
                    workingResource: resource,
                    resourceOperation: action
                });
                break;
            case 'activate':
                const subscriber = {
                    id: resource.id,
                    deleted_at: null
                };
                this.resourceActions.updateResource(subscriber, this.sendOptions);
                break;
            case 'profile':
                this.openUserViewModal(resource.id);
                break;
            case 'edit':
                this.openUserEditModal(resource.id);
                break;
            case 'workouts':
                this.props.history.push({pathname: '/workouts', query: {user_id: resource.id}})
                break;
            case 'reverify-subscription':
                this.setState({
                    reverifyLoading: true
                });
                SubscriptionsApi.reverify(this.state.workingResource.id);
                break;
        }
    },

    /**
     * Fire the deactivate user action
     */
    deactivateUser: function () {
        this.resourceActions.deactivateResource(this.state.workingResource, this.sendOptions);
    },

    updateUserInfo: function () {
        const user = this.state.workingResource;
        //delete user.receipts;
        delete user.activity_level;
        if (!user.expires_at.match(/.*\s\d+:\d+:\d+/)) {
            user.expires_at = user.expires_at + " 22:00:00";
        }
        if (user.receipts.length > 0) {
            user.receipts[0].expires_at = user.expires_at;
        }
        this.resourceActions.updateResource(this.state.workingResource, this.sendOptions);
    },

    /**
     * Close all modals and reset the working resource
     */
    closeModal: function () {
        this.setState({
            showUserViewModal: false,
            showUserEditModal: false,
            openDeactivateModal: false,
            workingResource: {}
        });
    },

    /**
     * Set up filter options
     */
    filterOptions: {
        "Unsubscribed Users": {
            expires_at: '<' + new Date().toISOString().slice(0, 19).replace('T', ' ')
        },
        "Never Subscribed": {
            expires_at: 'NULL'
        },
        "Annual App Subscribers": {
            'receipts.product.label': '=com.cyclecast.cyclecastapp.yearly',
            expires_at: '>' + new Date().toISOString().slice(0, 19).replace('T', ' ')
        },
        "Seminnual App Subscribers": {
            'receipts.product.label': '=com.cyclecast.cyclecastapp.semiannual',
            expires_at: '>' + new Date().toISOString().slice(0, 19).replace('T', ' ')
        },
        "Monthly App Subscribers": {
            'receipts.product.sku': '=com.cyclecast.cyclecastapp.monthly',
            expires_at: '>' + new Date().toISOString().slice(0, 19).replace('T', ' ')
        },
        "Deactivated Users": {
            deleted_at: 'NOT_NULL'
        }
    },

    /**
     * Map user object properties to table columns
     */
    tableKeys: {
        "User": "name",
        "Email": "username",
        "Sex": "gender",
        "Joined": "created_at",
        "Subscription Type": "receipts",
        "Expires at": "expires_at"
    },

    handleDayClick: function (dayClicked) {
        // get year, month, and day part from the date
        const year = dayClicked.toLocaleString("en-US", {year: "numeric"});
        const month = dayClicked.toLocaleString("en-US", {month: "2-digit"});
        const day = dayClicked.toLocaleString("en-US", {day: "2-digit"});

        // get the form resource
        const resource = _.cloneDeep(this.state.workingResource);

        // generate yyyy-mm-dd 00:00:00 date string
        resource.expires_at = `${year}-${month}-${day} 00:00:00`;

        this.setState({
            selectedDay: dayClicked,
            workingResource: resource,
        });
    },

    /**
     * Handle setting state to open the user view modal
     *
     * @param event
     */
    openUserViewModal: function (event) {
        let user;
        if (event === parseInt(event)) {
            // event is an integer
            user = SubscribersStore.getResourceById(event);
        } else {
            user = SubscribersStore.getResourceById(event.target.dataset.id);
        }

        this.setState({
            showUserViewModal: true,
            workingResource: user
        });
    },

    openUserEditModal: function (event) {
        let user;
        if (event === parseInt(event)) {
            // event is an integer
            user = _.cloneDeep(SubscribersStore.getResourceById(event));
        } else {
            user = _.cloneDeep(SubscribersStore.getResourceById(event.target.dataset.id));
        }

        this.setState({
            showUserEditModal: true,
            workingResource: user
        });
    },

    _determineSubscriptionType: function (user) {
        if (typeof user === 'undefined' || typeof user.receipts === 'undefined') {
            return 'No Data Available';
        }

        // Receipts are sorted in reverse chronological order, so the first one will always have the latest expiration.
        const mostRecentReceipt = user.receipts[0];
        if ((new Date(user.expires_at) < (new Date(new Date().toUTCString().substr(0, 25))))) {
            return 'Unsubscribed';
        } else if ((new Date(user.expires_at) > (new Date(new Date().toUTCString().substr(0, 25)))) && typeof mostRecentReceipt !== 'undefined') {
            return mostRecentReceipt.product.label;
        } else {
            return 'Pre-subscribed';
        }
    },

    render: function () {
        const options = {
            actionableRows: true,
            actions: ['profile:success', 'workouts:success', 'deactivate:danger', 'edit:warning'],
            actionsCallback: this.handleAction,
            hideSpinner: true,
            emptyText: 'No subscribers found.',
            mutators: {
                receipts: function (value, object) {
                    return this._determineSubscriptionType(object);
                }.bind(this),
                gender: function (value) {
                    return value === 0 ? 'Male' : value === 1 ? 'Female' : 'Other';
                },
                name: function (value, object) {
                    return <span onClick={this.openUserViewModal} data-id={object.id}>{value}</span>;
                }.bind(this),
                created_at: function (value) {
                    const date = new Date(value + ' UTC');
                    return date.toString();
                }
            }
        };

        const user = this.state.workingResource;
        const reverifyButtonText = this.state.reverifyLoading ? "Loading..." : "Re-verify Subscription";

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="6">
                            <h1 className="page-header">Accounts: Subscribers</h1>
                        </Column>

                        <Column grid="lg" size="4">
                            <div className="page-header">
                                <PageSearch actionMethod={this.requestTableData}
                                            searchable={['name', 'username']}/>
                            </div>
                        </Column>

                        <Column grid="lg" size="2" classes="float-right">
                            <Filter filters={this.filterOptions} actionMethod={this.requestTableData}/>
                        </Column>

                    </Row>

                    <Row>
                        <Column grid="lg" size="12">
                            <Table data={this.state.currentPageData}
                                   dataKeys={this.tableKeys}
                                   title={'Subscribers'} options={options}/>

                            <Paginator actionMethod={this.requestTableData}/>

                            <PerPageSelector actionMethod={this.requestTableData}/>

                        </Column>
                    </Row>
                </div>

                <Modal openWhen={this.state.showUserViewModal} options={{width: '30%'}}
                       title={user.name || 'User Profile'}
                       showButton="save" saveText="OK"
                       afterClose={this.closeModal}
                       afterSave={this.closeModal}>
                    <Column grid="lg" size="12">
                        <div className="subscriber-modal-body">
                            <p>
                                <strong>Name:</strong> {user.name || 'Anonymous'}</p>
                            <p>
                                <strong>Email Address:</strong> {user.username}</p>
                            <p>
                                <strong>Sex:</strong> {user.gender === 0 ? 'Male' : user.gender === 1 ? 'Female' : 'Other'}
                            </p>
                            <p>
                                <strong>Email Updates:</strong> {user.do_notify_email === 0 ? 'No' : 'Yes'}</p>
                            <p>
                                <strong>Type of Subscription:</strong> {this._determineSubscriptionType(user)}</p>
                            <p>
                                <strong>Expiration date:</strong> {user.expires_at}
                            </p>
                        </div>
                        <div className="spacer"/>
                    </Column>
                </Modal>

                <Modal openWhen={this.state.showUserEditModal} options={{width: '30%'}}
                       title={user.name || 'User Profile Edit'} closeText="Close"
                       saveText="Save" afterClose={this.closeModal}
                       beforeSave={this.updateUserInfo}
                       afterSave={this.closeModal}>
                    <Column grid="lg" size="12">
                        <div className="subscriber-modal-body">
                            <Form key={this.formKey + user.id} formKey={this.formKey} bindResource={user}>
                                <Label title="Name:" value={user.name}/>
                                <Form.Input fieldKey="username" type="email" label="Email Address:"
                                            placeholder="username@email.com"/>
                                <Label title="Sex:"
                                       value={user.gender === 0 ? 'Male' : user.gender === 1 ? 'Female' : 'Other'}/>
                                <Label title="Type of Subscription:" value={this._determineSubscriptionType(user)}/>
                                <Button action="reverify-subscription" text={reverifyButtonText}
                                        handleAction={this.handleAction}
                                        mods={['primary']} disabled={this.state.reverifyLoading}/>
                                <Form.Input fieldKey="expires_at" type="text" label="Expiration Date:"
                                            placeholder="yyyy-mm-dd" limit={10} required={true}/>
                                <div align="center">
                                    <DayPicker
                                        onDayClick={this.handleDayClick}
                                        month={user.expires_at ? new Date(user.expires_at) : new Date()}
                                        selectedDays={new Date(user.expires_at)}
                                    />
                                </div>
                            </Form>
                        </div>
                        <div className="spacer"/>
                    </Column>
                </Modal>

                <Modal openWhen={this.state.openDeactivateModal}
                       title="Deactivate?" closeText="Close"
                       saveText="Deactivate" afterClose={this.closeModal}
                       beforeSave={this.deactivateUser}
                       afterSave={this.closeModal}>
                    <p>You’re about to deactivate a resource.</p>
                    <p>Continue with deactivating their accounts&#63;</p>
                </Modal>
            </div>
        )
    },
});

module.exports = SubscribersPage;
